import { property, photos } from "../data/property";
import Reveal from "./Reveal";

export default function Story() {
  return (
    <section
      id="verhaal"
      data-testid="story-section"
      className="bg-brand-bg py-24 md:py-32"
    >
      <div className="mx-auto max-w-[1600px] px-6 md:px-12 lg:px-20">
        <div className="grid grid-cols-1 gap-12 md:grid-cols-12 md:gap-16">
          {/* Left text column */}
          <Reveal className="md:col-span-7 lg:col-span-6">
            <p className="overline">Het verhaal</p>
            <h2 className="mt-6 font-serif text-4xl leading-[1.05] tracking-tight text-brand-ink sm:text-5xl lg:text-6xl text-balance">
              Een licht en instapklaar familiehuis met{" "}
              <span className="italic">vrij uitzicht</span> over het groen.
            </h2>

            <div className="mt-10 hairline" />

            <div className="mt-10 space-y-6 text-lg leading-relaxed text-brand-muted">
              {property.story.map((p, i) => (
                <p key={i} data-testid={`story-paragraph-${i}`}>
                  {p}
                </p>
              ))}
            </div>

            <div className="mt-12 grid grid-cols-2 gap-8 border-t border-brand-border pt-10">
              <div>
                <p className="overline">Type</p>
                <p className="mt-2 font-serif text-xl text-brand-ink">
                  {property.type}
                </p>
              </div>
              <div>
                <p className="overline">Bouwjaar</p>
                <p className="mt-2 font-serif text-xl text-brand-ink">{property.yearBuilt}</p>
              </div>
              <div>
                <p className="overline">Inhoud</p>
                <p className="mt-2 font-serif text-xl text-brand-ink">{property.volume} m³</p>
              </div>
              <div>
                <p className="overline">Aanvaarding</p>
                <p className="mt-2 font-serif text-xl text-brand-ink">{property.acceptance}</p>
              </div>
            </div>
          </Reveal>

          {/* Right image column */}
          <Reveal className="md:col-span-5 lg:col-span-6" delay={0.15}>
            <div className="grid grid-cols-2 gap-4">
              <div className="aspect-[3/4] overflow-hidden">
                <img
                  src={photos[1]}
                  alt="Woonkamer Kempenaar 29"
                  className="h-full w-full object-cover transition-transform duration-700 hover:scale-105"
                  loading="lazy"
                />
              </div>
              <div className="aspect-[3/4] mt-12 overflow-hidden">
                <img
                  src={photos[14]}
                  alt="Woonkeuken Kempenaar 29"
                  className="h-full w-full object-cover transition-transform duration-700 hover:scale-105"
                  loading="lazy"
                />
              </div>
            </div>
            <p className="mt-6 text-center font-serif italic text-brand-muted">
              "Een huis dat u beslist van binnen moet komen bekijken."
            </p>
          </Reveal>
        </div>
      </div>
    </section>
  );
}
